export function PrivacyAgreement() {
  const pClasses = "mb-4 text-justify text-gray-700";
  return (
    <div>
      <h1 className="text-center text-3xl font-bold text-[#2c3e50] mb-8">
        匹配与决策智能体引擎系统隐私协议
      </h1>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        1. 服务内容
      </h2>
      <p className={pClasses}>
        1.1
        《達達隐私协议》（以下称"本政策"）适用于成都阳程智启软件有限公司及其关联公司（以下简称"我们"）推出的達達智慧物流智能服务（以下简称"匹配与决策智能体引擎系统"或"本服务"）。您在使用本服务前，请仔细阅读本政策，以了解我们处理您个人信息的详情。
      </p>
      <p className={pClasses}>
        1.2
        除非本隐私政策另有说明，本隐私政策适用于我们提供的達達智慧物流网页、应用程序、小程序、供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）以及随着技术发展出现的创新形态方式提供的产品和服务。如您使用我们或关联公司向您提供的達達智慧物流服务的某项或几项服务，有其单独的隐私政策，则相应服务或产品适用相应隐私政策；如未设立单独隐私政策的，则本政策同样适用于该部分产品或服务。
      </p>
      <p className={pClasses}>
        1.3
        请您知悉，终端用户访问开发者使用我们的开放平台服务开发的下游系统或应用时，其被收集的个人信息的处理规则不在本隐私政策的说明范围内，应由该应用的开发者作为个人信息处理者主动向终端用户披露相关个人信息保护规则。另外，如您通过匹配与决策智能体引擎系统链接到第三方网页、产品或服务，您接受第三方相关协议或政策对您的个人信息进行处理并履行相应权责。
      </p>
      <p className={pClasses}>
        1.4
        您可以通过访问相关功能或使用服务时，快速便捷了解我们收集个人信息的场景、目的和具体的数据类型。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        2. 我们如何使用Cookie和同类技术
      </h2>
      <p className={pClasses}>
        为了提供更优质的服务，我们会在您的设备上存储Cookie、Web
        Beacon等技术，用于识别您的身份、分析您的使用习惯、优化服务体验等。您可以通过浏览器设置拒绝或清除Cookie，但这可能会影响部分功能的正常使用。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        3. 我们如何委托处理、共同控制、转让、公开披露您的个人信息
      </h2>
      <p className={pClasses}>
        3.1
        我们不会将您的个人信息转让给任何未经您明确同意的第三方。在某些情况下，我们可能会委托第三方处理您的个人信息，如数据存储、技术支持、客户服务等。我们会与这些第三方签订严格的数据保护协议，要求他们按照我们的要求和相关法律法规处理您的个人信息。
      </p>
      <p className={pClasses}>
        3.2
        在合并、收购、资产转让等情况下，如涉及个人信息的转让，我们会要求新的持有您个人信息的公司或组织继续受本政策的约束，并要求其在获取您的明确同意前，不得改变个人信息的使用目的和方式。
      </p>
      <p className={pClasses}>
        3.3 我们不会公开披露您的个人信息，除非获得您的明确同意或法律另有规定。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        4. 知识产权
      </h2>
      <p className={pClasses}>
        4.1
        我们对達達服务及其相关内容（包括但不限于软件、代码、文本、图片、音频、视频等）拥有知识产权。未经我们明确书面许可，用户不得以任何形式复制、修改、传播、销售、出租、许可他人使用或进行其他商业利用。
      </p>
      <p className={pClasses}>
        4.2
        用户通过達達服务生成的内容，知识产权归用户所有，但用户应确保其对生成内容的使用不违反法律法规和本协议的规定。
      </p>
      <p className={pClasses}>
        4.3
        用户在使用達達服务时，授权我们使用、存储、处理其输入内容和生成内容，用于服务优化、模型训练等目的，但我们会对用户数据进行匿名化和去标识化处理。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        5. 隐私保护
      </h2>
      <p className={pClasses}>
        5.1
        我们重视用户隐私保护，将按照《達達隐私协议》的规定收集、使用、存储和保护用户个人信息。
      </p>
      <p className={pClasses}>
        5.2
        用户在使用達達服务时，应同意我们按照隐私政策的规定处理其个人信息。如用户不同意隐私政策，应立即停止使用服务。
      </p>
      <p className={pClasses}>
        5.3
        我们采取多种安全措施保护用户个人信息，包括但不限于加密技术、访问控制、安全审计等，但互联网环境并非绝对安全，我们无法完全保证用户信息的安全。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        6. 服务变更与中断
      </h2>
      <p className={pClasses}>
        6.1
        我们有权根据业务发展需要，变更、暂停或终止部分或全部服务，但应提前通知用户（除非因不可抗力或紧急情况导致无法提前通知）。
      </p>
      <p className={pClasses}>
        6.2 因以下原因导致服务中断或终止的，我们不承担责任：
      </p>
      <p className={pClasses}>
        6.3
        如我们终止服务，应按照相关法律法规的要求处理用户数据，并尽可能为用户提供数据导出等便利。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        7. 免责声明
      </h2>
      <p className={pClasses}>
        7.1
        匹配与决策智能体引擎系统仅供用户参考和使用，我们不对服务内容的准确性、完整性、适用性、及时性等作出任何保证。
      </p>
      <p className={pClasses}>
        7.2
        用户应自行承担因使用匹配与决策智能体引擎系统而产生的风险和后果。我们不对用户因使用服务而遭受的任何直接、间接、偶然、特殊或后续损失承担责任。
      </p>
      <p className={pClasses}>
        7.3
        我们不对第三方通过匹配与决策智能体引擎系统服务提供的内容或服务承担责任。用户与第三方之间的纠纷应自行解决。
      </p>
      <p className={pClasses}>
        7.4
        如因用户违反法律法规或本协议的规定，导致我们遭受损失（包括但不限于直接经济损失、商誉损失等），用户应承担赔偿责任。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        8. 协议更新
      </h2>
      <p className={pClasses}>
        8.1 我们有权根据法律法规的更新、业务的发展等因素，对本协议进行更新。
      </p>
      <p className={pClasses}>
        8.2
        当本协议发生变更时，我们会在匹配与决策智能体引擎系统显著位置公示变更内容，并通过适当方式通知用户。
      </p>
      <p className={pClasses}>
        8.3
        如用户继续使用匹配与决策智能体引擎系统服务，视为同意更新后的协议。如用户不同意更新后的协议，应立即停止使用服务。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        9. 法律适用与管辖
      </h2>
      <p className={pClasses}>
        9.1 本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。
      </p>
      <p className={pClasses}>
        9.2
        如用户与我们之间因本协议发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向有管辖权的人民法院提起诉讼。
      </p>
      <h2 className="text-2xl font-semibold text-[#34495e] mt-8 pb-2 border-b-2 border-blue-500">
        10. 其他
      </h2>
      <p className={pClasses}>
        10.1
        本协议构成用户与我们之间关于使用匹配与决策智能体引擎系统服务的完整协议，取代之前的任何口头或书面约定。
      </p>
      <p className={pClasses}>
        10.2 如本协议中的任何条款因违反法律法规而无效，不影响其他条款的效力。
      </p>
      <p className={pClasses}>
        10.3 如您对本协议有任何疑问或建议，请通过以下方式联系我们：
      </p>
      <p className={pClasses}>
        公司地址：中国(四川）自由贸易试验区天府新区兴隆街道湖畔路东段733号1栋3楼
      </p>
    </div>
  );
}
